import { DisplayField, DisplaySection } from "app/main/utils/uiUtils";
import moment from "moment";

const TruckInfo = ({ truckInfo, strategy }) => {
	return (
		<>
			<DisplaySection title="Driver Details">
				<div className="flex flex-row ">
					<DisplayField label="Carrier" value={truckInfo?.carrier__view?.label ?? "No information"} />
					<DisplayField
						label="Truck"
						value={`${truckInfo?.truck__view?.metadata?.equipment} - ${truckInfo?.truck__view?.metadata?.truckid}`}
					/>
					<DisplayField label="Driver Name" value={truckInfo?.driver__view?.label ?? "No information"} />
				</div>
			</DisplaySection>
			<DisplaySection title="Contract Details">
				<div className="flex flex-row ">
					<DisplayField
						label="Available Date"
						value={moment(strategy?.start_date).format("ddd MMM DD, YYYY") ?? "No information"}
					/>
					<DisplayField label="Available Location" value={strategy?.current_location ?? "No information"} />
					<DisplayField
						label="End Date"
						value={moment(strategy?.end_date).format("ddd MMM DD, YYYY") ?? "No information"}
					/>
					<DisplayField label="Desired Destination" value={strategy?.end_location ?? "No information"} />
				</div>
			</DisplaySection>
		</>
	);
};

export default TruckInfo;
